export const DRAWER_CONTAINER_ID = 'contentContainer'
